import { ReactNode, useEffect } from 'react'

interface ExitIntentTriggerProps {
  onExitIntentTrigger: () => void
}

const ExitIntentTrigger = ({
  onExitIntentTrigger,
}: ExitIntentTriggerProps): ReactNode => {
  useEffect(() => {
    document.addEventListener('mouseleave', onExitIntentTrigger, false)

    return () => {
      document.removeEventListener('mouseleave', onExitIntentTrigger)
    }
  }, [])

  return null
}

export default ExitIntentTrigger
